import { apiGet, apiPost } from '../services/apiClient';

const buildQuery = (params = {}) => {
  const qs = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '') qs.set(k, v);
  });
  const str = qs.toString();
  return str ? `?${str}` : '';
};

const BASE = '/api/admin/finance/payouts';

export const listPayouts = (token, params = {}) => apiGet(`${BASE}${buildQuery(params)}`, token);
export const listEligiblePayouts = (token, params = {}) => apiGet(`${BASE}/eligible${buildQuery(params)}`, token);
export const getPayout = (token, id) => apiGet(`${BASE}/${id}`, token);
export const createPayout = (token, payload) => apiPost(`${BASE}/create`, payload, token);
export const createPayoutBatch = (token, payload) => apiPost(`${BASE}/batch-create`, payload, token);
export const holdPayout = (token, id, payload) => apiPost(`${BASE}/${id}/hold`, payload, token);
export const unholdPayout = (token, id) => apiPost(`${BASE}/${id}/unhold`, {}, token);
export const schedulePayout = (token, id, payload) => apiPost(`${BASE}/${id}/schedule`, payload, token);
export const payNow = (token, id) => apiPost(`${BASE}/${id}/pay-now`, {}, token);
export const mockMarkPaid = (token, id) => apiPost(`${BASE}/${id}/mock-mark-paid`, {}, token);
